import { TermsSelectionContainer } from 'src/containers';

export const TermsSelection = () => <TermsSelectionContainer />;
